import { useEffect, type ReactNode } from 'react'
import { useUIStore } from '../store/uiStore'

// ── ThemeProvider — syncs dark mode state to <html> class ────────────────────
// Light mode is the default; dark class is applied to <html> when toggled.

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const darkMode = useUIStore((s) => s.darkMode)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode)
  }, [darkMode])

  return <>{children}</>
}
